export default __webpack_public_path__ + "static/media/048-noodles.8b6242cc.svg";